export interface EmailRequest {
  toAddress: string;
  template: string;
}

export interface TCMEmailRequest {
  toAddress: string;
  template: string;
  clientName: string;
}
export interface TCMEmailResponseSuccess {
  success: string;
  event: {
    emailId: string;
  };
}

export interface TCMEmailResponseFailure {
  Failed: string;
}
